import { Button } from '@mui/material'
import { useLogout } from 'react-admin';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

const LogoutButton:React.FC = () => {
  const logout = useLogout()

  return (
    <Button 
      className='logout' 
      onClick={() => logout({ source: 'button' })}
      sx={{ color: 'grey !important' }} 
    >
      <PowerSettingsNewIcon sx={{ mr: 1 }} />  Logout
    </Button>
  )
}

export default LogoutButton;